var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconErase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H22C22.5523 21 23 21.4477 23 22C23 22.5128 22.614 22.9355 22.1166 22.9933L22 23H2C1.44772 23 1 22.5523 1 22C1 21.4872 1.38604 21.0645 1.88338 21.0067L2 21H22H2ZM15.0297 3.83576L15.1798 3.97438L17.9973 6.73568C19.2827 7.99536 19.3334 10.0155 18.1428 11.327L18.0054 11.4697L9.59306 19.7142C9.43681 19.8673 9.23559 19.9641 9.02093 19.9918L8.89078 20L5.51779 19.9921C5.30036 19.9916 5.09027 19.9203 4.91844 19.7908L4.82019 19.7063L2.00266 16.945C0.717322 15.6853 0.666608 13.6651 1.85721 12.3537L1.99461 12.2109L10.4069 3.96649C11.6769 2.7219 13.7012 2.68043 15.0297 3.83576ZM4.823 12.238L3.3945 13.6393C2.90138 14.1226 2.87028 14.8829 3.30277 15.4079L3.40255 15.5166L5.92943 17.9931L8.48577 17.999L9.545 16.96L4.823 12.238ZM11.9192 5.29619L11.8068 5.39489L6.252 10.837L10.974 15.559L16.6055 10.0414C17.0986 9.55807 17.1297 8.79779 16.6972 8.27279L16.5975 8.16408L13.7799 5.40278C13.2707 4.90375 12.4633 4.86867 11.9192 5.29619Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconErase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconErase.4a15020c33be64f75e9ef779ff092725.svg";